<script setup lang="ts">
import Quill from "quill";

const editorRef = inject("quillEditor") as any;

const insertPageBreak = () => {
  const quill = editorRef.value?.getQuill?.();
  if (!quill) return;

  const range = quill.getSelection(true);
  if (!range) return;

  quill.insertEmbed(range.index, "pageBreak", true, Quill.sources.USER);

  // Insert a new line after the page break and hten move the cursor to the start of the new line
  quill.setSelection(range.index + 2, 0, Quill.sources.SILENT);
};
</script>

<template>
  <BaseIconButton @click="insertPageBreak()" v-tooltip="'Page Break'">
    <icon name="jam:page-break" size="18" class="text-medium" />
  </BaseIconButton>
</template>

<style scoped></style>
